import { Component, OnInit, AfterContentInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
import { trigger, style, animate, transition } from '@angular/animations';

declare let $: any;
declare let document;

@Component({
  standalone: false,
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
  animations: [
  trigger('fade', [
    transition('void => *', [
      style({ opacity: 0 }),
      animate(1300, style({ opacity: 1 }))
    ])
  ])
]
})
export class DetailComponent implements OnInit, AfterContentInit {

  data: any;
  show = true;
  currentCategory: string;
  kpisList = [];
  listCategories = [];
  porcent: number;
  scoring: number;
  hearts: any;
  aviso: string;

  constructor(private readonly route: Router, private readonly c: CommonsService, private readonly param: ActivatedRoute) {
    this.data = this.getData();
    this.data = (this.data.score) ? this.data : this.data.Scores[0];
    this.listCategories = this.data.score.CategoryScore;
  }

  ngOnInit() {
    this.prepareInformation(sessionStorage.getItem('currentCategory') || 0);
    this.c.firstChargePage('Detail', 'Vista detalle categoria', 'content');
    this.c.eventsAnalitics('visit screen', 'Detalle del resumen', 'Detail');
    // this.data.score.CategoryScore
  }

  ngAfterContentInit() {
    setTimeout(() => {
      $('#autoWidth').lightSlider({
        autoWidth: true,
        loop: false,
        onSliderLoad: () => {
          $('#autoWidth').removeClass('cs-hidden');
        }
      });
      document.querySelector('.lSAction').style.display = 'none';
      document.getElementsByClassName('lSPager')[0].style.display = 'none';
      this.show = false;
    }, 100);
  }

  getData() {
    let d = sessionStorage.getItem('_k') ? this.c.decrypt(sessionStorage.getItem('_k')) : this.c.getKpi();
    if (d.score) {
      d = (this.c.getKpi() && this.c.getKpi().kpis && this.c.getKpi().kpis.length)
        ? this.c.getKpi() : this.c.decrypt(sessionStorage.getItem('_k'));
    } else {
      d = (this.c.getKpi() && this.c.getKpi().Scores) ? this.c.getKpi() : this.c.decrypt(sessionStorage.getItem('_k'));
    }
    return d;
  }

  prepareInformation(index) {
    this.currentCategory = this.data.score.CategoryScore[index].CategoryName;
    this.kpisList = this.data.score.CategoryScore[index].CategoryKpiList;
    this.porcent = this.data.score.CategoryScore[index].Porcent;
    this.scoring = this.data.score.CategoryScore[index].CategoryScoreNumber;
    this.hearts = {
      heart1: this.kpisList.filter(d => d.DescriptionBack && d.Heart === 1),
      heart2: this.kpisList.filter(d => d.DescriptionBack && d.Heart === 2 && d.Heart === 0),
      heart3: this.kpisList.filter(d => d.DescriptionBack && d.Heart === 3)
    };
    this.c.eventsAnalitics('click', 'Menu categorías', this.currentCategory);
    this.getMessage(index);
  }


  getMessage(i) {
    if (+i === 1) {
      this.aviso = this.data.score.warning;
    } else {
      this.aviso = '';
    }
  }

  getColor(num: number) {
    switch (num) {
      case 10:
      case 9:
      case 8:
      case 7:
        return '#007A5E';
      case 6:
      case 5:
        return '#AD8A00';
      case 4:
      case 3:
        return '#B04626';
      case 2:
      case 1:
      case 0:
        return '#B22B35';
    }
  }

  backToDetail() {
    this.c.eventsAnalitics('click', 'Atras', 'Detail');
    this.route.navigateByUrl('/global-position/summary/main');
  }
}
